module.exports = __webpack_public_path__ + "static/media/utility_pole_wood.1909e42e.png";